/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/overload/"

const OVERLOAD: CommunityData = {
  code: "overload",
  inviteCode: "overload",
  name: "Overload",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/ove-304`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#FFF",
      logo: {
        src: "https://media.werz.at/community/icon/cmn77allc00009kre4fyact2x.jpg?uploadTime=1774516398215&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png?v=1`,
        styles: "w-[94px] h-[95px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "!p-0 !gap-0 border-r border-[#8d8d8d]",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      mainFont: "font-['ABCSocialUnlicensedTrialRegular']",
      primaryButton:
        "bg-[#333333] border border-[#333333] px-[18px] py-[18px] gap-y-[6px] !text-[#ffffff] font-['ABCSocialMonoUnlicensedTrialMedium'] !text-[16px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ebebeb",
      sideBarSeparator: "border-r-[1px] border-[#8d8d8d]",
      separator: "border-[#8d8d8d]",
      item: "font-['ABCSocialCondensedUnlicensedTrialRegular'] text-[18px] text-[#ebebeb] uppercase text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#8d8d8d] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#8d8d8d] !pb-8",
      titles:
        "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[26px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#8d8d8d]",
        sectionTitle:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#8d8d8d]",
        sectionTitle:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[17px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[26px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "",
      bgMobile: "",
      bgColor: "#000000",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#000000] px-4 py-12 sm:p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#8d8d8d] object-cover",
        name: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[26px] uppercase text-center leading-[110%] mt-4 mb-1",
        location:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-center leading-[110%] mb-2",
        description:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[17px] text-center leading-[120%] mb-4 max-w-[500px]",
        socialMediaIconColor: "#d5d5d5",
        button:
          "bg-[#000000] border border-[#8d8d8d] px-[12px] py-[12px] text-[#ffffff] font-['ABCSocialMonoUnlicensedTrialMedium'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] bg-[#000000] text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#8d8d8d]",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] bg-[#000000] border border-[#8d8d8d] flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title:
            "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-center leading-[110%] mb-1",
          text: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[17px] text-center leading-[120%]",
          button:
            "bg-[#000000] border border-[#8d8d8d] px-[12px] py-[12px] text-[#ffffff] font-['ABCSocialMonoUnlicensedTrialMedium'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] bg-[#000000] border border-[#8d8d8d] flex justify-between",
          duration:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%]",
          name: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#d5d5d5",
          media: "border border-[#8d8d8d] overflow-hidden m-2",
        },
        event: {
          container: "bg-[#000000] border border-[#8d8d8d] overflow-hidden sm:w-[500px] w-[95vw]",
          name: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-left leading-[110%] mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] bg-[#333333] border border-[#8d8d8d] text-[#ffffff] flex flex-col justify-center items-center gap-1 font-['ABCSocialMonoUnlicensedTrialMedium'] text-[14px] uppercase",
          duration:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%]",
          location:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%]",
          button:
            "bg-[#000000] border border-[#8d8d8d] px-[12px] py-[12px] text-[#ffffff] font-['ABCSocialMonoUnlicensedTrialMedium'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] border-t border-[#8d8d8d] px-4 py-3 flex justify-between gap-4",
            name: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[14px] uppercase text-left leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-left leading-[110%]",
            link: "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%]",
            status:
              "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[14px] uppercase text-left leading-[110%]",
            button:
              "bg-[#000000] border border-[#8d8d8d] px-[12px] py-[12px] text-[#ffffff] font-['ABCSocialMonoUnlicensedTrialMedium'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] bg-[#000000] text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#8d8d8d]",
        header:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#000000] sm:w-[500px] w-[95vw] border border-[#8d8d8d] flex justify-between",
          name: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#d5d5d5",
          created:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%]",
          media: "border border-[#8d8d8d] overflow-hidden m-2",
        },
        seeAllNews:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] bg-[#000000] text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#8d8d8d]",
        header:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer bg-[#000000] sm:w-[500px] w-[95vw] border border-[#8d8d8d] flex justify-between",
          coverUrl: "border border-[#8d8d8d] overflow-hidden m-2",
          duration:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%]",
          liveType:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%]",
          liveTypeCircle: "w-2 h-2 bg-[#d5d5d5] rounded-full",
          playIconColor: "#d5d5d5",
          start:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-left leading-[120%]",
          title:
            "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] bg-[#000000] text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#8d8d8d]",
        header:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] bg-[#000000] w-[95vw] border border-[#8d8d8d] flex justify-between",
          name: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase leading-[110%]",
          triangleIconColor: "#d5d5d5",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#8d8d8d] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[12px] text-center leading-[120%]",
      },
    },
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop:
          "https://media.werz.at/community-assets/overload/mobile-landing-background.mp4?type=video",
        mobile:
          "https://media.werz.at/community-assets/overload/mobile-landing-background.mp4?type=video",
        style: "bg-[#222222]",
      },
      logo: {
        desktop: `https://media.werz.at/community-assets/overload/web-alternative-logo.png`,
        mobile: `https://media.werz.at/community-assets/overload/web-alternative-logo.png`,
        style: "w-[70px] h-[71px] sm:w-[94px] sm:h-[95px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['ABCSocialUnlicensedTrialRegular'] text-[28px] leading-[120%] text-[#d5d5d5]",
      text: "font-['ABCSocialUnlicensedTrialRegular'] text-[16px] leading-[120%] text-[#d5d5d5]",
      button:
        "font-['ABCSocialMonoUnlicensedTrialMedium'] text-[14px] leading-[120%] uppercase p-4 bg-[#333333] text-[#ffffff] cursor-pointer w-fit",
      input: {
        base: "font-['ABCSocialUnlicensedTrialRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#222222] text-[#d5d5d5]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['ABCSocialUnlicensedTrialRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText:
        "font-['ABCSocialUnlicensedTrialRegular'] text-[14px] leading-[120%] text-[#8d8d8d]",
      skipButton:
        "font-['ABCSocialUnlicensedTrialRegular'] text-[14px] leading-[120%] text-[#8d8d8d] cursor-pointer",
      socHideLogo: true,
      modal: {
        container: "bg-[#222222] px-[40px] py-[48px]",
        title:
          "font-['ABCSocialUnlicensedTrialRegular'] text-[24px] leading-[120%] text-[#d5d5d5] text-center",
        text: "font-['ABCSocialUnlicensedTrialRegular'] text-[14px] leading-[120%] text-[#8d8d8d] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#d5d5d5] bg-[#000000] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border border-[#8d8d8d] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#8d8d8d]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[26px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#333333] border border-[#333333] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['ABCSocialMonoUnlicensedTrialMedium'] !text-[16px] uppercase text-left leading-[100%]",
        questions: "text-[15px] text-left leading-[120%] text-[#8d8d8d]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#8d8d8d]",
        header:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#8d8d8d]",
        header:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#ffffff",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[22px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border border-[#8d8d8d] px-[12px] py-[12px] text-[#ffffff] font-['ABCSocialMonoUnlicensedTrialMedium'] text-[14px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#000000] border-b border-[#8d8d8d] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#d5d5d5] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#ffffff] font-['ABCSocialMonoUnlicensedTrialMedium'] text-[14px] uppercase text-left leading-[100%]",
          status:
            "text-[#a7a7a7] font-['ABCSocialUnlicensedTrialRegular'] text-[16px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border border-[#8d8d8d] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border border-[#8d8d8d] px-[12px] py-[12px] text-[#ffffff] font-['ABCSocialMonoUnlicensedTrialMedium'] text-[14px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default OVERLOAD
